// /presentations DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import type { GridColDef } from "@mui/x-data-grid";
import { IPresentation } from "../interfaces";

export const presentationColumns: GridColDef<IPresentation>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  { field: "place", headerName: "장소", type: "string", width: 140, minWidth: 110 },
  {
    field: "centerId",
    headerName: "시설ID",
    type: "string",
    width: 120,
    minWidth: 100,
  },
  {
    field: "content",
    headerName: "내용",
    type: "string",
    width: 280,
    minWidth: 160,
  },
  {
    field: "startDate",
    headerName: "시작일",
    type: "string",
    width: 116,
    minWidth: 108,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "endDate",
    headerName: "종료일",
    type: "string",
    width: 116,
    minWidth: 108,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 150,
    minWidth: 120,
    align: "center",
    headerAlign: "center",
  },
];
